export const GA_TRACKING_ID = 'UA-147515990-1'
